var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('select-custom-fields', {
    attrs: {
      "value": _vm.value,
      "disabled": _vm.disabled,
      "label": _vm.$t('views.CustomFieldList.selectCustomField'),
      "types": _vm.types,
      "omitIds": _vm.omitIds,
      "showManageButton": _vm.showManageButton
    },
    on: {
      "change": function change($event) {
        return _vm.$emit('change', $event);
      },
      "input": function input($event) {
        return _vm.$emit('input', $event);
      }
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }